import {FoodOrderingState, GlobalState} from '@/types/state'
import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import * as getterTypes from '@/store/getter-types'
import {DailyMenuChangeSet} from '@/types'
import {createInitialDailyMenuTopGroupChangeSetUpdate, updateSelectedItemByOfferId} from '@/services/food-orderingGroup'
import moment from 'moment'
import axios from '@/plugins/axios'
import {USER_DAILY_MENU, USER_SETTINGS_4_ORDERING} from '@/store/action-types'
import Moment from 'moment'
import store from '@/store'
import {USER_LOGGED_IN} from '@/store/getter-types'
import {
  ChangeExistingReservationStatusPayload, ChangeExistingReservationWithIdPayload, CreateNewReservationPayload,
  FetchOfferReservationPayload,
  FetchStructuredMenuOfferPayload, FetchStructuredMenuOfferWithCancelTokenPayload,
  PlaceNewReservationPayload
} from '@/types/payload'
import {
  InvoiceResponseItem,
  MyLatestInvoiceResponse,
  OfferReservationResponse,
  StructuredMenuOfferResponse
} from '@/types/service-response'
import {AxiosResponse} from 'axios'
import MenuOffer from "@/model/dailymenu/MenuOffer";
import DailyMenuOfferOrder from "@/model/dailymenu/DailyMenuOfferOrder";
import MenuGroupItem from "@/model/dailymenu/MenuGroupItem";
import MenuReservation from "@/model/dailymenu/MenuReservation";
import MenuReservationItem from "@/model/dailymenu/MenuReservationItem";
import DailyMenuOptionOrder from "@/model/dailymenu/DailyMenuOptionOrder";

const state: FoodOrderingState = {
  userDailyMenu: MenuOffer.createEmpty(),
  loadingData: false,
  templateDailyMenu: MenuOffer.createEmpty(),
  currentDailyMenuOffer: undefined,
  currentDailyMenuTopGroupOffer: undefined,
  dailyMenuTopGroupChangeSet: undefined,
  dailyMenuChangeSet: undefined,
  currentUserReservationRangeData: undefined,
  reservationDataSaved: undefined,
  userSettings4Ordering: undefined,
  currentDailyMenuTemplate: undefined,
  searchFoodItems: undefined,

}


const getters = {

  [getterTypes.MENU_OFFER](state: FoodOrderingState): MenuOffer {
    return state.userDailyMenu
  },

  [getterTypes.DAILY_MENU_OFFER](state: FoodOrderingState): DailyMenuOfferOrder | undefined {
    return state.currentDailyMenuOffer
  },

  [getterTypes.DAILY_MENU_TOP_GROUP_OFFER](state: FoodOrderingState): MenuGroupItem | undefined {
    return state.currentDailyMenuTopGroupOffer
  },

  [getterTypes.DAILY_MENU_CHANGE_SET](state: FoodOrderingState): DailyMenuChangeSet | undefined {
    return state.dailyMenuChangeSet
  },

  [getterTypes.DAILY_MENU_TOP_GROUP_CHANGE_SET](state: FoodOrderingState): any | undefined {
    return state.dailyMenuTopGroupChangeSet
  },

  [getterTypes.LOADING_DAILYMENU](state: FoodOrderingState): boolean {
    return state.loadingData
  },

  [getterTypes.CURRENT_USER_RESERVATION_RANGE_DATA](state: FoodOrderingState): MenuReservation | undefined {
    return state.currentUserReservationRangeData
  },

  [getterTypes.DAILY_MENU_TOP_GROUP_SAVED](state: FoodOrderingState): MenuReservation | undefined {
    return state.reservationDataSaved
  },

  [getterTypes.USER_SETTINGS_4_ORDERING](state: FoodOrderingState): MenuReservation | undefined {
    return state.userSettings4Ordering
  },
}

const mutations = {

  [mutationTypes.SET_CURRENT_USER_DAILYMENU](state: FoodOrderingState, payload: MenuOffer): void {
    state.userDailyMenu = payload
  },

  [mutationTypes.SET_CURRENT_DAILYMENU_OFFER](state: FoodOrderingState, payload: DailyMenuOfferOrder): void {
    state.currentDailyMenuOffer = payload
  },

  [mutationTypes.SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER](state: FoodOrderingState, payload: MenuGroupItem): void {
    state.currentDailyMenuTopGroupOffer = payload
  },

  [mutationTypes.SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET](state: FoodOrderingState, payload: any): void {
    state.dailyMenuTopGroupChangeSet = payload
  },

  [mutationTypes.SET_DAILYMENU_OFFER_CHANGE_SET](state: FoodOrderingState, payload: DailyMenuChangeSet | undefined): void {
    state.dailyMenuChangeSet = payload
  },
  [mutationTypes.SET_LOADING_DAILYMENU](state: FoodOrderingState, payload: boolean): void {
    state.loadingData = payload
  },

  [mutationTypes.SET_CURRENT_USER_RESERVATION_RANGE_DATA](state: FoodOrderingState, payload: any): void {
    state.currentUserReservationRangeData = payload
  },

  [mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED](state: FoodOrderingState, payload: any): void {
    state.reservationDataSaved = payload
  },

  [mutationTypes.SET_USER_SETTINGS_4_ORDERING](state: FoodOrderingState, payload: any): void {
    state.userSettings4Ordering = payload
  },
}

const actions = {

  async [actionTypes.USER_SETTINGS_4_ORDERING]({commit}: { commit: Function }, payload: any): Promise<void> {

    if (payload) {
      const settingsData = {
        last_ordering: {
          hour: '18:00',
          days_before: '1'
        }
      }

      commit(mutationTypes.SET_USER_SETTINGS_4_ORDERING, settingsData)

    }

  },

  async [actionTypes.USER_DAILY_MENU]({commit, dispatch}: { commit: Function, dispatch: Function }, payload: any): Promise<void> {

    const user = store.getters[USER_LOGGED_IN]

    if (payload) {
      let headers = {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }

      dispatch(USER_SETTINGS_4_ORDERING, {})

      commit(mutationTypes.SET_LOADING_DAILYMENU, true)
      let menuOfferDataResponse = await axios.get('/api/food-ordering/' + user.tenant.code + '/menu-offer?s=' + payload.from + '&e=' + payload.to, {headers: headers})

      let reservationDataResponse = await axios.get('/api/food-ordering/offer-reservation?date[before]=' + payload.to + '&date[after]=' + payload.from + '&boarder.id=' + payload.user_id, {headers: headers})

      const offerData = MenuOffer.createFromResponse(menuOfferDataResponse.data)
      commit(mutationTypes.SET_CURRENT_USER_DAILYMENU, offerData)

      const reservationData = MenuReservation.createFromResponse(reservationDataResponse.data)
      commit(mutationTypes.SET_CURRENT_USER_RESERVATION_RANGE_DATA, reservationData)

      commit(mutationTypes.SET_LOADING_DAILYMENU, false)
    }

  },

  async [actionTypes.SWITCH_DAILYMENU]({commit}: { commit: Function }, payload: any): Promise<void> {

    if (payload.day == undefined) {
      return
    }

    commit(mutationTypes.SET_LOADING_DAILYMENU, true)

    commit(mutationTypes.SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER, payload.topGroup)

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    let res = await axios.get('/api/food-ordering/offer-reservation?date[before]=' + payload.day + '&date[after]=' + payload.day + '&boarder.id=' + payload.user_id, {headers: headers})

    const changeSet = createInitialDailyMenuTopGroupChangeSetUpdate(payload, res.data)
    commit(mutationTypes.SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET, changeSet)

    updateSelectedItemByOfferId(res.data)

    commit(mutationTypes.SET_LOADING_DAILYMENU, false)

  },

  async [actionTypes.STORNO_DAILYMENU]({commit, state, dispatch}: { commit: Function, state: FoodOrderingState, dispatch: Function }, payload: any): Promise<void> {


    let order: any | undefined = state.dailyMenuTopGroupChangeSet
    let date = order.date
    let list = order.selectedItemList
    let offer_ids: number[] = []
    let topgroupId = order.topGroupId
    let reservationId = order.reservationId

    list.forEach((item: any) => {
      offer_ids.push(item.selectedItem.offer.id)
    })

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    let data = {
      'status': 'canceled',
      'reservedOfferCollection': offer_ids
    }

    let res = await axios.put('/api/food-ordering/offer-reservation/' + reservationId, data, {headers: headers})

    const changeSet = {reservationId: reservationId, status: data.status}
    commit(mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED, changeSet)

    if (state.userDailyMenu && state.userDailyMenu.menuList.length > 0) {
      const start_date = Moment(state.userDailyMenu.menuList[0].date).format('Y-MM-DD')
      const end_date = Moment(state.userDailyMenu.menuList[state.userDailyMenu.menuList.length - 1].date).format('Y-MM-DD')

      dispatch(USER_DAILY_MENU, {from: start_date, to: end_date, user_id: order.user_id})

    }
  },

  async [actionTypes.SAVE_DAILYMENU]({commit, state, dispatch}: { commit: Function, state: FoodOrderingState, dispatch: Function }, payload: any): Promise<void> {

    let order: any | undefined = state.dailyMenuTopGroupChangeSet
    let date = order.date
    let list = order.selectedItemList
    let offer_ids: number[] = []
    let topgroupId = order.topGroupId
    let reservationId = order.reservationId

    list.forEach((item: any) => {
      offer_ids.push(item.selectedItem.offer.id)
    })

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
    //
    let data = {
      'status': 'active',
      'reservedOfferCollection': offer_ids
    }

    let res = await axios.put('/api/food-ordering/offer-reservation/' + reservationId, data, {headers: headers})

    const changeSet = {reservationId: reservationId, status: data.status}
    commit(mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED, changeSet)

    if (state.userDailyMenu && state.userDailyMenu.menuList.length > 0) {
      const start_date = Moment(state.userDailyMenu.menuList[0].date).format('Y-MM-DD')
      const end_date = Moment(state.userDailyMenu.menuList[state.userDailyMenu.menuList.length - 1].date).format('Y-MM-DD')

      dispatch(USER_DAILY_MENU, {from: start_date, to: end_date, user_id: order.user_id})

    }

  },

  async [actionTypes.SAVE_RESTORE_DAILYMENU]({commit, state, dispatch}: { commit: Function, state: FoodOrderingState, dispatch: Function }, payload: any): Promise<void> {

    var order: any | undefined = state.dailyMenuTopGroupChangeSet
    let reservationId = order.reservationId

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
    //
    let data = {
      'status': 'active'
    }

    let res = await axios.put('/api/food-ordering/offer-reservation/' + reservationId, data, {headers: headers})

    const changeSet = {reservationId: reservationId, status: data.status}
    commit(mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED, changeSet)

    if (state.userDailyMenu && state.userDailyMenu.menuList.length > 0) {
      const start_date = Moment(state.userDailyMenu.menuList[0].date).format('Y-MM-DD')
      const end_date = Moment(state.userDailyMenu.menuList[state.userDailyMenu.menuList.length - 1].date).format('Y-MM-DD')

      dispatch(USER_DAILY_MENU, {from: start_date, to: end_date, user_id: order.user_id})

    }

  },

  /**
   * Načítanie rezervácií používateľa pre dátumový rozsah
   *
   * Dáta obsahujú informácie o stave objednávky na daný deň a položky ktoré sú v objednávke.
   *
   * @param payload FetchStructuredMenuOfferPayload
   */
  async [actionTypes.FETCH_OFFER_RESERVATION]({}, payload: FetchOfferReservationPayload): Promise<OfferReservationResponse> {
    const response: AxiosResponse = await axios.get('/api/food-ordering/offer-reservation', {
      params: {
        'date[before]': moment(payload.dateTo).format('YYYY-MM-DD'),
        'date[after]': moment(payload.dateFrom).format('YYYY-MM-DD'),
        'boarder.id': payload.boarderId
      },

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return response.data as OfferReservationResponse
  },

  /**
   * Vytvorenie novej rezerácie jedla na daný deň
   *
   * @param rootState
   * @param payload PlaceNewReservationPayload
   */
  async [actionTypes.PLACE_NEW_RESERVATION]({rootState}: { rootState: GlobalState }, payload: CreateNewReservationPayload): Promise<MenuReservationItem> {
    let offerIds: number[] = []
    //payload.selection.forEach((value) => offerIds.push(parseInt(value.offer!.id)))

    const response: AxiosResponse = await axios.post('/api/food-ordering/offer-reservation', payload,  {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })
    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Zmena existujúcej rezerácie jedla
   *
   * @param payload ChangeExistingReservationPayload
   */
  async [actionTypes.CHANGE_EXISTING_RESERVATION]({}, payload: ChangeExistingReservationWithIdPayload): Promise<MenuReservationItem> {
    const response: AxiosResponse = await axios.put(`/api/food-ordering/offer-reservation/${payload.reservationId}`, payload.payload, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  async [actionTypes.CHANGE_EXISTING_RESERVATION_STATUS]({}, payload: ChangeExistingReservationStatusPayload): Promise<MenuReservationItem> {

    const response: AxiosResponse = await axios.put(`/api/food-ordering/offer-reservation/${payload.reservationId}`, {
      acceptanceStatus: payload.acceptanceStatus
    }, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Zrušenie existujúcej rezervácie
   *
   * @param payload MenuReservationItem
   */
  async [actionTypes.CANCEL_EXISTING_RESERVATION]({}, payload: MenuReservationItem): Promise<MenuReservationItem> {
    const response: AxiosResponse = await axios.put(`/api/food-ordering/offer-reservation/${payload.reservationId}`, {
      status: 'canceled'
    }, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Obnovenie zrušenej rezervácie
   *
   * @param payload MenuReservationItem
   */
  async [actionTypes.RESTORE_EXISTING_RESERVATION]({}, payload: MenuReservationItem): Promise<MenuReservationItem> {
    const response: AxiosResponse = await axios.put(`/api/food-ordering/offer-reservation/${payload.reservationId}`, {
      status: 'active'
    }, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Načítanie najnovších vyúčtovaní
   */
  async [actionTypes.FETCH_MY_LATEST_INVOICES]({}): Promise<MyLatestInvoiceResponse> {
    const response: AxiosResponse = await axios.get(`/api/my/invoice/latest`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return response.data
  },

  async [actionTypes.DOWNLOAD_INVOICE]({}, payload: InvoiceResponseItem): Promise<void> {
    const response = await axios.get(`/api/invoice/${payload.id}/download`, {
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    const blob = new Blob([response.data], { type: 'application/pdf' })
    const link = document.createElement('a')

    link.href = URL.createObjectURL(blob)
    link.download = response.headers['content-disposition'].split('=')[1]
    link.click()
    URL.revokeObjectURL(link.href)
  }
}

const foodOrderingModule = {
  state,
  getters,
  mutations,
  actions
}

export default foodOrderingModule
